import { render } from "./Principles.vue?vue&type=template&id=2f3e6dd1&scoped=true"
import script from "./Principles.vue?vue&type=script&lang=js"
export * from "./Principles.vue?vue&type=script&lang=js"

import "./Principles.vue?vue&type=style&index=0&id=2f3e6dd1&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3e6dd1"]])

export default __exports__